import { recordsConstants } from '../constants/records.constants';

const defaultState = {
	playing: false,
	records: [],
	recordPosition: 0,
	duration: 0,
//	recordId: undefined,
//    request: undefined,
	dataFetching: false,
	dataFetchingDownload: false,
	playbackRate: 1,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case recordsConstants.FETCH_RECORDS + '_FULFILLED': {
			return {
				...state,
				records: action.payload.data.data || action.payload.data,
				dataFetching: false,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORDS + '_PENDING': {
			return {
				...state,
				dataFetching: true,
			} 
		}
		case recordsConstants.FETCH_RECORDS +'_REJECTED': {
			return {
				...state,
				dataFetching: false,
				apiResponseError: action.payload.response.status,
				apiResponseText: action.payload.response.statusText,
				apiResponseURL: action.payload.response.request.responseURL
			}
		}
		case recordsConstants.FETCH_RECORD_DOWNLOAD + '_START': {
			return {
				...state,
				recordIdDownload: action.payload,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD_DOWNLOAD + '_FULFILLED': {
			return {
				...state,
				dataFetchingDownload: false,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD_DOWNLOAD + '_PENDING': {
			return {
				...state,
				dataFetchingDownload: true,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD_DOWNLOAD +'_REJECTED': {
			return {
				...state,
				dataFetchingDownload: false,
				apiResponseError: action.payload,
				apiResponseText: "ошибка чтения данных",
			}
		}
		case recordsConstants.FETCH_RECORD: {
			return {
				...state,
				recordId: action.payload,
				dataFetching: true,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD + '_FULFILLED': {
			return {
				...state,
				record: action.payload.data.data || action.payload.data,
				dataFetching: false,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD + '_PENDING': {
			return {
				...state,
				dataFetching: true,
				apiResponseError: null,
			}
		}
		case recordsConstants.FETCH_RECORD +'_REJECTED': {
			return {
				...state,
				playing: false,				
				recordId: -1,
				duration: 0,
				recordPosition: 0,
				dataFetching: false,
				apiResponseError: action.payload,
				apiResponseText: "ошибка чтения данных",
				//apiResponseURL: action.payload.response.request.responseURL
			}
		}
		case recordsConstants.DATA_DECODE_ERROR: {
			return {
				...state,
				dataFetching: false,
				apiResponseError: true,
				apiResponseText: action.payload,
			}
		}
		case recordsConstants.PLAY_RECORD: {
			return {
				...state,
				playing: true,
				recordPosition: 0,
				recordId: action.payload,
				duration: action.recdurt,
				apiResponseError: null,
				dataFetching: false
			}
		}
		case recordsConstants.SET_RECORD_POS: {
			return {
				...state,
				recordPosition: action.payload,				
			}
		}
		case recordsConstants.STOP: {
			return {
				...state,
				playing: false,				
				recordId: -1,
				duration: 0,
				recordPosition: 0,
			}
		}
		case recordsConstants.PAUSE: {
			return {
				...state,
				playing: false,				
			}
		}
		case recordsConstants.SET_PLAYBACK_RATE: {
			return {
				...state,
				playbackRate: action.payload,				
			}
		}
		case recordsConstants.RESUME: {
			return {
				...state,
				playing: true,				
				dataFetching: false
			}
		}
		default:
			return state;
	}
}